import { Box, Container, Divider, Typography, Grid, Button } from '@mui/material'
import { memo, useEffect, useState } from 'react'

const NumberChoiceQuestion = memo(({ dataQuestion, indices, form }) => {
  const [inputValue, setInputValue] = useState('')
  const [pressedKey, setPressedKey] = useState(null)

  const handleNumberClick = (num) => {
    setInputValue((prev) => {
      if (prev.length >= 6) return prev
      return prev + num
    })
  }

  // eslint-disable-next-line
  const handleClear = () => setInputValue('')
  // eslint-disable-next-line
  const handleBackspace = () => setInputValue((prev) => prev.slice(0, -1))
  const handleEnter = () => {
    form.setValue(`question_${indices}`, inputValue)
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      setPressedKey(e.key)

      if (e.key >= '0' && e.key <= '9') {
        setInputValue((prev) => {
          if (prev.length >= 6) return prev
          return prev + e.key
        })
      } else if (e.key === 'Backspace') {
        handleBackspace()
      } else if (e.key.toLowerCase() === 'c') {
        handleClear()
        // } else if (e.key === 'Enter') {
        //   // langsung submit form parent
        //   document.querySelector('form')?.requestSubmit()
        // }
      } else if (e.key === 'Enter') {
        e.preventDefault()
        handleEnter()
      }
    }

    const handleKeyUp = () => setPressedKey(null)

    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('keyup', handleKeyUp)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('keyup', handleKeyUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleBackspace, handleClear])

  useEffect(() => {
    form.setValue(`question_${indices}`, inputValue || null)
  }, [inputValue, form, indices])

  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'} mx={'-1rem'}>
      {/* Header soal */}
      <Box
        bgcolor={'#9AA5EA'}
        width={'100%'}
        sx={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <Divider sx={{ backgroundColor: 'white', height: '3px' }} />
        <Box px={2} py={3}>
          <Container style={{ display: 'flex', justifyContent: 'center' }}>
            {dataQuestion.link_gambar === '' ? null : (
              <img src={dataQuestion.link_gambar} alt="img-soal" />
            )}
          </Container>
          <Typography
            variant="inherit"
            textAlign={'center'}
            fontWeight={'bold'}
            fontSize={'14px'}
            letterSpacing={1.2}
            lineHeight={1.7}
            backgroundColor={'white'}
            maxWidth={'150px'}
            borderRadius={'10px'}
            mx={'auto'}
            padding={2}
            sx={{ whiteSpace: 'pre-wrap' }}
          >
            {dataQuestion.soal}
          </Typography>
        </Box>
      </Box>

      {/* Input keypad */}
      <Box p={2}>
        <Typography variant="h6" align="center" mb={2}>
          {inputValue || '_'}
        </Typography>

        {form.formState.errors?.[`question_${indices}`] && (
          <Typography variant="inherit" color="error" textAlign="center" sx={{ my: 1 }}>
            *{form.formState.errors[`question_${indices}`]?.message}
          </Typography>
        )}

        <Grid container spacing={1}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <Grid item xs={4} key={num}>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  minHeight: 70,
                  bgcolor: pressedKey === String(num) ? '#d1d1d1' : '#fff',
                  color: '#000',
                  transform: pressedKey === String(num) ? 'scale(0.95)' : 'scale(1)',
                  transition: 'all 0.1s ease',
                }}
                onClick={() => handleNumberClick(num)}
              >
                {num}
              </Button>
            </Grid>
          ))}

          {/* Tombol Clear (C) */}
          <Grid item xs={4}>
            <Button
              fullWidth
              color="error"
              variant="contained"
              sx={{
                minHeight: 70,
                transform: pressedKey?.toLowerCase() === 'c' ? 'scale(0.95)' : 'scale(1)',
                transition: 'all 0.1s ease',
              }}
              onClick={handleClear}
            >
              C
            </Button>
          </Grid>

          {/* Tombol 0 */}
          <Grid item xs={4}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                minHeight: 70,
                bgcolor: pressedKey === '0' ? '#d1d1d1' : '#fff',
                color: '#000',
                transform: pressedKey === '0' ? 'scale(0.95)' : 'scale(1)',
                transition: 'all 0.1s ease',
              }}
              onClick={() => handleNumberClick(0)}
            >
              0
            </Button>
          </Grid>

          {/* Tombol Backspace */}
          <Grid item xs={4}>
            <Button
              fullWidth
              color="warning"
              variant="contained"
              sx={{
                minHeight: 70,
                transform: pressedKey === 'Backspace' ? 'scale(0.95)' : 'scale(1)',
                transition: 'all 0.1s ease',
              }}
              onClick={handleBackspace}
            >
              ←
            </Button>
          </Grid>

          {/* Tombol Enter */}
          <Grid item xs={12}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              type="submit"
              sx={{
                minHeight: 70,
                transform: pressedKey === 'Enter' ? 'scale(0.95)' : 'scale(1)',
                transition: 'all 0.1s ease',
              }}
              onClick={handleEnter}
            >
              ⏎ Enter
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}, arePropEqual)

function arePropEqual(oldProps, newProps) {
  return oldProps.indices !== newProps.indices
}
export default NumberChoiceQuestion
